import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { showMoreThreshold } from './utils'
import PanelFooter from './panelFooter'
import PanelBody from './panelBody'
import PanelHeader from './panelHeader'

class FiltersSingleSelectPanel extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isExpanded: false
    }

    this.toggleOption = this.toggleOption.bind(this)
  }

  toggleOption (event) {
    event.preventDefault()
    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }

  render () {
    const { isExpanded } = this.state
    const { items, showPanel, togglePanel, rootCount, parsedLocation, type, breadcrumbsLabel } = this.props
    const isExpandable = items.length > showMoreThreshold[type]

    const panelBodyClassNames = classNames(
      'search-facet-panel__body', {
        'is-active': showPanel
      }
    )

    return (
      <div className={panelBodyClassNames}>
        <div className='search-facet-panel__body-inner'>
          <button className='search-facet-panel__body-close fds-c-button' onClick={togglePanel}>
            <i className='e-icon -icon-cancel'>
              <span className='e-icon__alt'>Close</span>
            </i>
          </button>

          <PanelHeader
            togglePanel={togglePanel}
            parsedLocation={parsedLocation}
            rootCount={rootCount}
            type={type}
            breadcrumbsLabel={breadcrumbsLabel}
          />

          <PanelBody
            isExpandable={isExpandable}
            isExpanded={isExpanded}
            togglePanel={togglePanel}
            parsedLocation={parsedLocation}
            items={items}
            type={type}
          />

          {isExpandable &&
            <PanelFooter
              isExpandable={isExpandable}
              isExpanded={isExpanded}
              moreOptionCount={items.length - showMoreThreshold[type]}
              toggleOption={this.toggleOption}
              togglePanel={togglePanel}
            />
          }
        </div>
      </div>
    )
  }
}

FiltersSingleSelectPanel.propTypes = {
  items: PropTypes.array.isRequired,
  parsedLocation: PropTypes.object.isRequired,
  showPanel: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  rootCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  breadcrumbsLabel: PropTypes.string.isRequired
}

export default FiltersSingleSelectPanel



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/singleSelect.js